module.exports = __webpack_public_path__ + "static/media/George Clooney_1680017321216.27f3c082.jpg";